import React, { useMemo } from "react";
import clsx from "clsx";
import { useParams } from "react-router-dom";

import { bankBalanceHeaders, bankBalanceDefaultColumns } from "./constants";
import { EditableTable } from "./editableTable";
import { mapToEditableRows } from "./helpers";

import styles from "./tables.module.scss";

const BankBalanceTable = ({
	bankBalances,
	addBankBalance,
	editBankBalance,
	deleteBankBalance,
	isEditable = true,
	showEmptyBlock,
	dateFormat = "MM/DD/YYYY",
	loading,
	count,
	page,
	handlePageChange,
	hideFooter,
}) => {
	const { underwritingTab } = useParams();
	const rows = useMemo(
		() =>
			mapToEditableRows(
				bankBalances,
				bankBalanceDefaultColumns,
				dateFormat,
			),
		[bankBalances, dateFormat],
	);

	const isCrediBalanceTab = underwritingTab ? "" : "mb-4";

	return (
		<EditableTable
			rows={rows}
			headers={bankBalanceHeaders}
			columnsStructure={bankBalanceDefaultColumns}
			useFirstRowForAddition={isEditable}
			className={styles.bankBalanceTable}
			headerClassName={
				isEditable ? styles.wrapHeaderWithAction : styles.wrapHeader
			}
			bodyClassName={clsx(styles.wrapBody, isCrediBalanceTab)}
			actionsClassName={styles.actions}
			onAdd={addBankBalance}
			onEdit={editBankBalance}
			onDelete={deleteBankBalance}
			isEditable={isEditable}
			showEmptyBlock={showEmptyBlock}
			handlePageChange={handlePageChange}
			count={count}
			page={page}
			hideFooter={hideFooter}
			loading={loading}
		/>
	);
};

export default BankBalanceTable;
